import type { CallConversation } from "@/playground/components/DevHome/table/graphql/types";
import type { TranscriptType } from "./transcript.constants";

export const getTranscript = (
  conversation: CallConversation
): TranscriptType | undefined => {
  /** At the moment we only care about the 'available'
   * status but all others have been kept because of the
   * possibility of getting them back in the future.
   */
  switch (conversation.transcription?.status) {
    case "available":
      return "AVAILABLE";
    case "lowConfidence":
      return "LOW_CONFIDENCE";
    case "noSpeechDetected":
      return "NO_SPEECH_DETECTED";
    case "badAcoustics":
      return "BAD_ACOUSTICS";
    default:
      break;
  }
};
